<template>
  <div class="spe-bottom-tab" :ddt-area="`component_${json.floorId}_底部tab组件`" ddt-expose="on">
    <div class="spe-bottom-tab-bg" :style="commonStyle">
      <a
        v-for="(el, index) in jdata.tabsData"
        :key="index"
        @click="$sys.dict.href(el.jumpUrl)"
        :ddt-src="el.title"
        :data-area="pt()"
        :data-pos="`component_${json.floorId}_底部tab组件.坑位${index + 1}_点击`"
        :data-desc="el.title"
        :dd_name="`${pt()}.component_${json.floorId}_底部tab组件.坑位${index + 1}_点击.${el.title}`"
        :ddt-click="`${pt()}.component_${json.floorId}_底部tab组件.坑位${index + 1}_点击.${el.title}`"
        :ddt-pit="`坑位${index + 1}_点击`"
        ddt-expose="on"
      >
        <img v-lazy="el.image" />
      </a>
    </div>
  </div>
</template>


<script>
export default {
    props: {
        json: {
            type: Object,
            default: () => {
                return {};
            },
        },
        pagebgcolor:'',
        isMina: {
            type: Boolean,
            default: false
        },
        isIos: {
            type: Boolean,
            default: false
        },
        isAndroid: {
            type: Boolean,
            default: false
        }
    },
    components: {},
    data() {
        return {};
    },
    inject: ['pt'],
    computed: {
        jdata() {
            return this.json.data || { commonStyle: {}, tabStyle: {}, tabsData: [] };
        },
      commonStyle() {
        let sty = {};
        if (this.jdata.commonStyle.backgroundType == 1) {
          if (this.jdata.commonStyle.usePageBackgroundColor) {
            sty.backgroundColor =this.jdata.commonStyle.bgColor
          }else{
            sty.backgroundColor = this.jdata.commonStyle.backgroundColor;
          }
        } else if(this.jdata.commonStyle.backgroundType == 2){
          //背景图
          sty.backgroundImage = `url(${this.jdata.commonStyle.backgroundImage})`;
        }
        if(this.isMina && this.isIos) {
          sty.paddingBottom = '34px'
        }
        return sty;
      },
    },
    watch: {},
    methods: {

    },
    filters: {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.spe-bottom-tab {

    .spe-bottom-tab-bg {
      width: 750px;
      height: 100px;
      background-size: cover;
      position: fixed;
      left: auto;
      right: auto;
      bottom: 0;
      z-index: 10;
      display: flex;
      background-repeat: no-repeat;
      background-position: left top;
      background-size: 100% 100%;
        a {
            flex: 1;
            text-align: center;
            img {
                width: 100px;
                height: 100px;
            }
        }
    }
}
</style>
